import { Article } from '../models/articles';
import type { OpenAPIV3_1 } from 'openapi-types';

export const findEndpointDefinitionByArticleId = async (article: Article) => {
  if (!article.endpoint?.swaggerFile) {
    return null;
  }

  return parseSwagger(article.endpoint.swaggerFile).then((swaggerDoc) => {
    if (!swaggerDoc) return null;
    return findSwaggerRecord(article, swaggerDoc);
  });
};

export function findSwaggerRecord(
  article: Article,
  swaggerDoc: OpenAPIV3_1.Document
) {
  const endpointMethod = article.endpoint?.method;

  const endpointPath = article.endpoint?.path ?? '';

  const matchingPath =
    // @ts-expect-error: endpointMethod.toLowerCase() will not play very well with this type unfortunately
    swaggerDoc.paths?.[endpointPath]?.[endpointMethod.toLowerCase()];

  return matchingPath as OpenAPIV3_1.OperationObject;
}

export async function parseSwagger(
  swaggerFilePath: string
): Promise<OpenAPIV3_1.Document | null> {
  try {
    const SwaggerParser = await import('@apidevtools/swagger-parser');
    const parser = new (SwaggerParser as any).default();
    return await parser.validate(swaggerFilePath);
  } catch (error) {
    console.error('An error occurred:', error);
    return null;
  }
}
